import { render, staticRenderFns } from "./SelectDiagnostics.vue?vue&type=template&id=db3c2d50"
import script from "./SelectDiagnostics.vue?vue&type=script&lang=js"
export * from "./SelectDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./SelectDiagnostics.vue?vue&type=style&index=0&id=db3c2d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports